import { takeLatest, call, put } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import {
  setAllFilters,
  setFieldDropDownData,
  getFieldType,
  setSaveFilter,
  setWalletConTypeFilterData,
  setExpenseConTypeFilterData,
  getAllSaveFilters,
  storeAppliedFilter,
  getFieldDropDownData,
} from '../actions/filterSearchActions';
import { setLoader } from '../actions/loaderAction';
import * as SnackbarAction from '../actions/snackbarAction';

export function* fetchAllFilters(actions) {
  try {
    const response = yield call(
      callApi,
      URLS.GET_SEARCH_FIELDS,
      'GET',
      actions.payload,
    );

    if (
      response &&
      response.res_data &&
      response.res_data.fields &&
      response.res_data.fields.length
    ) {
      yield put(setAllFilters(response.res_data.fields));
      yield put(getFieldType(response.res_data.fields[0]));
      if (response.res_data.fields?.[0]?.url) {
        yield put(
          getFieldDropDownData({
            query: { ...actions.payload },
            url: response.res_data.fields?.[0]?.url,
          }),
        );
      }
    }
  } catch (error) {
    // console.log(`API failed`);
  }
}
export function* fetchFieldDropDownData(actions) {
  try {
    const response = yield call(
      callApi,
      actions.payload.url,
      'GET',
      actions.payload.query,
    );

    yield put(setFieldDropDownData(response.res_data.choices));
  } catch (error) {
    yield put(setFieldDropDownData([]));
    // console.log(`API failed`);
  }
}
export function* fetchSaveFilter(actions) {
  try {
    const response = yield call(
      callApi,
      URLS.SAVE_FILTERS,
      'GET',
      actions.payload,
    );
    yield put(setSaveFilter(response.res_data.search_query));
  } catch (error) {
    // console.log(`API failed`);
  }
}

export function* applySearchQuery(actions) {
  try {
    const response = yield call(callApi, URLS.SEARCH, 'GET', actions.payload);
    yield put(setLoader(false));
    yield put(storeAppliedFilter(actions.payload.query));
    switch (actions.payload.content_type) {
      case 'wallet': {
        const payload = {
          data: response.res_data.result,
          count: response.res_data.count,
        };
        yield put(setWalletConTypeFilterData(payload));
        break;
      }
      case 'cc_transaction': {
        yield put(setExpenseConTypeFilterData(response.res_data));
        break;
      }

      default:
        break;
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
export function* SaveFilterQuery(actions) {
  try {
    const response = yield call(
      callApi,
      URLS.SAVE_FILTER,
      'POST',
      actions.payload,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
    const query = {
      content_type: actions.payload.content_type,
    };
    if (actions && actions.payload && actions.payload.has_role) {
      query.has_role = true;
    }
    yield put(getAllSaveFilters(query));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* setDownlodEtl(action) {
  try {
    const response = yield call(
      callApi,
      URLS[action.url],
      'GET',
      action.payload,
    );
    // if (
    //   response.res_data.link &&
    //   response.res_data.link !== '' &&
    //   response.res_data.link !== true
    // ) {
    //   window.open(response.res_data.link, '_self');
    // }
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* showSnackBar(action) {
  try {
    yield put(
      SnackbarAction.openSnackbar({
        message: action.data.msg,
        type: action.data.type,
      }),
    );
  } catch (error) {
    // console.log(error)
  }
}

export function* FilterSaga() {
  yield takeLatest('GET_ALL_FILTER', fetchAllFilters);
  yield takeLatest('GET_FIELD_DD_DATA', fetchFieldDropDownData);
  yield takeLatest('GET_SAVE_FILTER', fetchSaveFilter);
  yield takeLatest('SEARCH_QUERY', applySearchQuery);
  yield takeLatest('SAVE_FILTER', SaveFilterQuery);
  yield takeLatest('DOWNLOAD_ETL', setDownlodEtl);
  yield takeLatest('SHOW_SNACK_BAR', showSnackBar);
}
